"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapWithReduxStoreContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const wrapWithReduxStoreContainer = (BaseComponent, wrapperProps) => {
    const WrappedComponent = props => {
        return ((0, jsx_runtime_1.jsx)(react_redux_1.Provider, { store: wrapperProps.store, children: (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, props)) }));
    };
    return WrappedComponent;
};
exports.wrapWithReduxStoreContainer = wrapWithReduxStoreContainer;
//# sourceMappingURL=reduxStoreWrapper.js.map